<template>
    <div class="event-card-header">
        <div class="event-photo">
            <img
                v-if="currentEvent.picture"
                alt="img"
                :src="currentEvent.picture"
                class="event-photo-img"
            />
            <img
                v-if="!currentEvent.picture"
                :src="getIcon + 'default-artist-event.png'"
                class="event-photo-img"
            />
        </div>
        <div class="event-date-time">
            <div class="event-date">
                <div class="event-date-time-complete">
                    <div class="time-event">
                        <span v-if="currentEvent.date !== '12:00-12:00 AM'" class="event-date">
                            {{ currentEvent.date }}
                        </span>
                    </div>
                    <div class="event-manage-actions">
                        <button class="btn-underline-header">
                            <span @click="goToEventsList" class="btn-decorate"
                                >Back to events</span
                            >
                        </button>
                        <EventManageMenu
                            v-if="mode !== 'artistEvent'"
                            :current-event="currentEvent"
                        />
                    </div>
                </div>
                <div class="event-title" v-if="currentEvent.title">
                    <p>{{ currentEvent.title }}</p>
                </div>
                <div v-if="mode === 'artistEvent'" class="venue-name">
                    At {{ currentEvent.venue_name }}
                </div>
                <div class="artist-vibe-info">
                    <div class="bid-budget" v-if="mode !== 'artistEvent'">
                        {{ payoutLanguage }}
                    </div>
                    <div class="bid-budget" v-else>
                        {{ artistPayoutLanguage }}
                    </div>
                    <div class="vibe-container d-flex align-items-center">
                        <div class="atist-vibe">Vibe:</div>
                        <div v-if="currentEvent.vibe" class="vibe-tag-info">
                            <div
                                class="event-tag"
                                v-for="(vide, index) in currentEvent.vibe.split(',')"
                                :key="index"
                            >
                                {{ vide }}
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="event-status-panel">
                    <span v-if="width > 1000 && mode !== 'artistEvent'" class="status-start"
                        >Status:</span
                    >
                    <div v-if="!showCompleted" class="d-flex align-item-center">
                        <div
                            v-if="showAvailsChecked"
                            :class="{ 'event-btn-checked-done': currentEvent.status === 0 }"
                            class="event-btn-checked"
                        >
                            <p v-if="mode !== 'artistEvent'" class="event-btn-avails">
                                Avails Checked
                            </p>
                            <p v-if="mode === 'artistEvent'" class="event-btn-avails">
                                {{ !currentEvent.status ? 'Invited to Apply' : 'Applied' }}
                            </p>
                        </div>
                        <img
                            v-if="currentEvent.status === 1 && !mode"
                            class="arrow"
                            :src="getIcon + 'arrow-event-booking.png'"
                        />
                        <img
                            v-if="
                                currentEvent.status === 1 &&
                                currentEvent.event_artist_status === 0 &&
                                mode === 'artistEvent'
                            "
                            class="arrow"
                            :src="getIcon + 'arrow-event-booking.png'"
                        />
                        <div
                            v-if="showBookArtist && !mode"
                            class="event-btn-checked"
                            :class="{
                                'event-btn-checked-done': currentEvent.status === 1
                            }"
                        >
                            <p @click="getBookPage" class="event-btn-avails">
                                {{
                                    currentEvent.status === 2 ? 'Artist Booked' : 'Book Artist'
                                }}
                            </p>
                        </div>
                        <div
                            v-if="showBookArtist && mode === 'artistEvent'"
                            class="event-btn-checked"
                            :class="{
                                'event-btn-checked-done':
                                    currentEvent.status === 1 &&
                                    currentEvent.event_artist_status === 0
                            }"
                        >
                            <p @click="getBookPage" class="event-btn-avails">
                                {{
                                    currentEvent.status > 1 ||
                                    currentEvent.event_artist_status === 3
                                        ? 'Booked'
                                        : 'Get Booked'
                                }}
                            </p>
                        </div>
                        <img
                            v-if="currentEvent.status === 2 && !mode"
                            class="arrow"
                            :src="getIcon + 'event-advance-arrow.png'"
                        />
                        <img
                            v-if="
                                currentEvent.event_artist_status === 3 &&
                                mode === 'artistEvent'
                            "
                            class="arrow"
                            :src="getIcon + 'event-advance-arrow.png'"
                        />
                        <div
                            v-if="showAdvance && !mode"
                            class="event-btn-checked"
                            :class="{
                                'event-btn-advance-done': currentEvent.status === 2
                            }"
                        >
                            <p @click="getAdvancePage" class="event-btn-avails">
                                {{ currentEvent.status > 2 ? 'Advanced' : 'Advance' }}
                            </p>
                        </div>
                        <div
                            v-if="showAdvance && mode === 'artistEvent'"
                            class="event-btn-checked"
                            :class="{
                                'event-btn-advance-done':
                                    currentEvent.status === 2 ||
                                    currentEvent.event_artist_status === 3
                            }"
                        >
                            <p @click="getAdvancePage" class="event-btn-avails">
                                {{ currentEvent.status > 2 ? 'Advanced' : 'Advance' }}
                            </p>
                        </div>
                        <img
                            v-if="currentEvent.status === 3"
                            class="arrow"
                            :src="getIcon + 'wrap-up-arrow.png'"
                        />
                        <div
                            v-if="showWrapUp"
                            :class="{ 'event-btn-wrap-up-done': currentEvent.status === 3 }"
                            class="event-btn-checked"
                        >
                            <p class="event-btn-avails">Wrap Up</p>
                        </div>
                    </div>
                    <div
                        v-if="showCompleted"
                        :class="{ 'event-btn-checked-done': currentEvent.status === 0 }"
                        class="event-btn-checked mx-2"
                    >
                        <p class="event-btn-avails event-btn-completed">
                            <img
                                class="completed-event-checkmark"
                                src="/images/check-mark-black.svg"
                                alt="checkmark"
                            />
                            Event complete
                        </p>
                    </div>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import useFormattedData from '@/composables/useFormattedData'
    import { notification } from '@/helpers/notification'
    import checkScreen from '@/mixins/check-screen'
    import EventManageMenu from '../parts/manage-event-menu/EventManageMenu.vue'
    import moment from 'moment'

    export default {
        name: 'EventManageHeader',
        components: {
            EventManageMenu
        },
        mixins: [checkScreen],
        props: {
            eventId: {
                type: Number
            },
            userId: {
                type: Number
            },
            eventDate: {
                type: String
            },
            mode: {
                type: String
            },
            eventIdInvite: {
                type: Number
            },
            dataUpdated: {
                type: Boolean
            }
        },
        setup() {
            const { formatTimeString } = useFormattedData()

            return {
                formatTimeString
            }
        },
        data: () => ({
            currentEvent: {},
            eventTitle: '',
            counterOfferData: {},
            eventStatus: null,
            pastEventDate: Boolean
        }),
        computed: {
            artistPayoutLanguage() {
                let payout

                if (Object.keys(this.currentEvent).length === 0) return ''

                if (
                    this.currentEvent?.individual_payouts &&
                    this.currentEvent.individual_payouts.length &&
                    this.currentEvent.individual_payouts.find(
                        (p) => p.users_artist_id === this.userId
                    )?.payout
                ) {
                    payout = this.currentEvent.individual_payouts.find(
                        (p) => p.users_artist_id === this.userId
                    ).payout

                    return this.currentEvent.status < 2
                        ? `Est. Payout: $${payout}`
                        : `Final Payout: $${payout}`
                } else {
                    return this.currentEvent.status < 2
                        ? `Est. Payouts: N/A`
                        : `Final Payouts: N/A`
                }
            },
            payoutLanguage() {
                return this.currentEvent.status < 2
                    ? `Est. Payouts: ${
                          parseInt(this.currentEvent.total_payout)
                              ? '$' + this.currentEvent.total_payout
                              : 'N/A'
                      }`
                    : `Final Payouts: $${this.currentEvent.total_payout}`
            },
            getIcon() {
                return '/images/'
            },
            showAvailsChecked() {
                if (this.width < 1000) {
                    return this.currentEvent.status === 0
                }
                return true
            },
            showBookArtist() {
                if (this.width < 1000) {
                    return this.currentEvent.status === 1 || this.currentEvent.status === 2
                }
                return true
            },
            showAdvance() {
                if (this.width < 1000) {
                    return (
                        this.currentEvent.status === 1 ||
                        this.currentEvent.status === 2 ||
                        this.currentEvent.status === 3
                    )
                }
                return true
            },
            showWrapUp() {
                if (this.width < 1000) {
                    return this.currentEvent.status === 3
                }
                return true
            },
            showCompleted() {
                return this.currentEvent.status === 4
            }
        },
        methods: {
            async getHeaderInfo() {
                try {
                    const eventId = this.eventId
                    const response = await axios.get(
                        '/api/events/' + eventId + '/event-top-info'
                    )
                    this.currentEvent = response.data.data
                    const {
                        budget,
                        budget_without_commission,
                        vibe,
                        duration,
                        date,
                        counter_offer_status,
                        bid_artists_info,
                        title,
                        time,
                        venue_name,
                        venue_id,
                        max,
                        min,
                        picture,
                        description,
                        status,
                        start_time,
                        event_type,
                        event_artist_status,
                        cover_cost,
                        opportunity_detail,
                        address,
                        booking_id,
                        min_age,
                        individual_payouts,
                        artist_fee,
                        venue_subscription
                    } = this.currentEvent
                    this.counterOfferData = {
                        budget,
                        budget_without_commission,
                        vibe,
                        duration,
                        date,
                        counter_offer_status,
                        bid_artists_info,
                        title,
                        time,
                        venue_name,
                        venue_id,
                        max,
                        min,
                        picture,
                        description,
                        status,
                        start_time,
                        event_type,
                        event_artist_status,
                        cover_cost,
                        booking_id,
                        opportunity_detail,
                        address,
                        min_age,
                        individual_payouts,
                        artist_fee,
                        venue_subscription
                    }
                    const currentDate = moment()
                    const eventDate = moment(this.currentEvent.date, 'ddd MMMM Do, YYYY')
                    this.pastEventDate = eventDate.isBefore(currentDate)
                    this.$emit('update:eventStatus', this.counterOfferData.status)
                    this.$emit('update:counterOfferData', this.counterOfferData)
                    this.$emit('update:eventDate', this.currentEvent.date)
                } catch (error) {
                    notification('error', error)
                }
            },
            goToEventsList() {
                window.location.href = '/booking-manager'
            },
            getBookPage() {
                if (
                    this.currentEvent.status >= 0 &&
                    this.currentEvent.status <= 2 &&
                    !this.mode &&
                    !this.pastEventDate
                ) {
                    window.location.href = '/event/book-artist'
                } else {
                    return
                }
            },
            getAdvancePage() {
                if (this.currentEvent.status === 2 && !this.mode && !this.pastEventDate)
                    window.location.href = '/event/advance-book-artist'
                if (this.currentEvent.status === 2 && this.mode === 'artistEvent')
                    window.location.href = '/booking-manager/artist/advance'
            },
            async saveEventTitle() {
                try {
                    const payload = {}
                    const eventId = this.eventIdInvite ? this.eventIdInvite : this.eventId
                    if (this.eventTitle) payload.event_name = this.eventTitle
                    const response = await axios.put(
                        '/api/event/manage/update/' + eventId,
                        payload
                    )
                    notification('success', response.data.message)
                    window.location.reload()
                } catch (error) {
                    notification('error', 'Please enter the event title')
                }
            },
            async fetchHeaderDataAndUpdate() {
                await this.getHeaderInfo()
                this.$forceUpdate()
                this.$emit('update:dataUpdated', false)
            }
        },
        watch: {
            async dataUpdated(newValue) {
                if (newValue) {
                    await this.fetchHeaderDataAndUpdate()
                }
            }
        },
        async created() {
            await this.getHeaderInfo()
            localStorage.setItem('eventDate', this.currentEvent.date)
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../../sass/_variables.scss';
    .arrow {
        margin-right: 5px;
    }
    .event-card-header {
        flex-basis: 20%;
        @include flex-row;
        padding: 0 50px;
        align-items: center;
        width: 100%;
        max-width: 1050px;
    }
    .event-photo {
        min-height: 180px;
        min-width: 180px;
        border-radius: 10px;
    }
    .event-photo-img {
        max-width: 180px;
        max-height: 180px;
        border-radius: 10px;
    }
    .event-title {
        margin-top: 10px;
        @include flex-col;
        @include base-font-26;
        font-weight: 600;
        line-height: 120%;
        list-style-position: outside;
        padding: 0;
        color: $white;
    }
    .event-title-input {
        background: none;
        border: none;
        color: $white;
    }
    .time-event {
        color: $darker-grey;
        @include base-font-20;
        font-weight: 550;
        line-height: 120%;
        display: flex;
        align-items: center;
        gap: 20px;
    }
    .event-date-time-complete {
        @include flex-row;
        justify-content: space-between;
        max-width: 800px;
    }
    .hours-input {
        background: none;
        border: none;
        color: $darker-grey;
    }
    .event-date-time {
        @include flex-col;
        margin-left: 25px;
        width: 100%;
        max-width: 750px;
    }

    .event-date {
        @include base-font-44;
        line-height: 110%;
        padding: 0;
        color: $white;
    }

    .status-start {
        @include base-font-20;
        font-weight: 600;
        line-height: 120%;
        hanging-punctuation: first last;
        list-style-position: outside;
        padding: 0;
        color: $darker-grey;
    }

    .event-status-panel {
        @include flex-row;
        justify-content: flex-start;
        align-items: center;
        margin-top: 10px;
    }
    .event-btn-avails {
        background: $lighter-dark;
        border-radius: 100px;
        padding: 7px 20px 10px 20px;
        min-width: 123px;
        text-wrap: nowrap;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 14px;
        margin-right: 5px;
        margin-bottom: 0;
        cursor: pointer;
    }
    .event-btn-completed {
        color: black;
        margin-left: 0px;
    }
    .completed-event-checkmark {
        margin-right: 10px;
    }
    .event-btn-checked {
        color: $darker-grey;
        @include base-font-14;
        font-weight: 600;
        line-height: 125%;
    }
    .event-btn-advance-done {
        @include base-font-14;
        font-weight: 600;
        line-height: 125%;
        list-style-position: outside;
        padding: 0;
        color: $gold;
        border-radius: 100px;
        border: 1px solid $gold;
        background: $dark;
    }
    .event-btn-checked-done {
        @include base-font-14;
        font-weight: 600;
        line-height: 125%;
        list-style-position: outside;
        padding: 0;
        color: $lime-2;
        border-radius: 100px;
        border: 1px solid $lime-2;
        background: $lighter-dark;
    }
    .event-btn-advance-done p {
        background: transparent;
    }
    .event-btn-wrap-up-done {
        @include base-font-14;
        font-weight: 600;
        line-height: 125%;
        list-style-position: outside;
        padding: 0;
        color: $violet-2;
        border-radius: 100px;
        border: 1px solid $violet-2;
        background: $dark;
    }
    .event-btn-wrap-up-done p {
        background: transparent;
    }
    .btn-underline-header {
        border: none;
        background: none;
    }
    .btn-decorate {
        text-decoration: underline;
        color: $grey;
        text-align: center;
        @include base-font-16;
        font-weight: 600;
        line-height: 120%;
    }
    .artist-vibe-info {
        display: flex;
        margin-right: 60px;
        margin-bottom: 25px;
        align-items: center;
    }

    .atist-vibe {
        color: $darker-grey;
        @include base-font-26;
        font-weight: 600;
        line-height: 120%;
    }
    .bid-budget {
        color: $darker-grey;
        @include base-font-20;
        font-weight: 550;
        line-height: 120%;
        margin-right: 50px;
    }
    .vibe-container {
        overflow: auto;
    }
    .venue-name {
        color: $darker-grey;
        @include base-font-26;
        line-height: 120%;
        letter-spacing: -0.52px;
        margin-bottom: 12px;
    }
    .vibe-tag-info {
        align-items: center;
        display: flex;
        @include base-font-12;
        font-weight: 650;
        line-height: 135%;
    }
    .vibe-container {
        -ms-overflow-style: none; /* Internet Explorer 10+ */
        scrollbar-width: none; /* Firefox */
    }
    .vibe-container::-webkit-scrollbar {
        display: none; /* Safari and Chrome */
    }
    .event-tag {
        color: $darker-grey;
        @include base-font-16;
        font-weight: 600;
        line-height: 120%;
        border: 1px solid $grey;
        border-radius: 100px;
        padding: 3px 10px 4px;
        margin: 5px;
        min-width: max-content;
    }

    @media (max-width: 1000px) {
        .event-card-header {
            flex-wrap: wrap;
            margin: 0;
            padding: 0 16px;
            gap: 20px;
        }
        .time-event {
            flex-wrap: wrap;
        }
        .event-date-time-complete {
            flex-wrap: wrap;
        }
        .event-date-time {
            margin-left: 0;
        }
        .event-date {
            font-size: 32px;
        }
        .artist-vibe-info {
            flex-wrap: wrap;
            gap: 16px;
            margin-top: 16px;
        }
        .event-status-panel {
            flex-wrap: wrap;
            gap: 3px;
        }
        .event-photo-img {
            border-radius: 10px;
            max-height: 240px;
            min-width: 100%;
            object-fit: cover;
        }
        .event-photo {
            max-height: 240px;
            min-width: 100%;
        }
        .hours-input {
            margin-left: 0;
        }
        .atist-vibe {
            font-size: 16px;
        }
        .event-btn-avails {
            background: transparent;
        }
        .event-btn-completed {
            background: $grey;
        }
        .event-btn-checked-done {
            background: transparent;
        }
        .event-btn-checked {
            border: 1px solid;
            border-radius: 100px;
        }
        .event-btn-avails {
            margin: 0;
        }
        .vibe-tag-info {
            max-width: 320px;
            overflow-y: scroll;
        }
    }
</style>
